import React from "react"
import { has } from "lodash"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

const PACKAGE_PREFIX = 'com.funovus.';

class ApplicationForm extends React.Component{
    constructor(){
        super()
        this.state = {
            appName: "",
            appNameError: "",
            packageName: "",
            packageNameError: ""
        }
        this.whiteSpaceTest = /^\s+$/
        this.appNameTest = /[\w\d\.\ ]+/
        this.packageNameTest= /^[\w]+$/
        this.packageInput = React.createRef()
    }
    handleChange = (e) =>{
        const {name, value} = e.target
        this.setState({
            [name]: value,
            appNameError: "",
            packageNameError: ""
        })
        //actively validate if fields are not empty
        if (this.state.appName !== "" && this.state.packageName !== "" && this.supportEmail !== ""){
            this.validate();
        }
    }
    handleSubmit = (e) =>{
        e.preventDefault()
        if(this.validate()){
            fetch(`/api/data/project/${this.props.projectId}/appConfig/`,{
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appName: this.state.appName,
                    packageName: PACKAGE_PREFIX + this.state.packageName
                })
            })
            .then(res => res.json())
            .then(data =>{
                if(has(data, "error")){ throw data }
                this.props.getAppConfig()
            })
            .catch(data => this.setState({appNameError: `Server: ${data.error}`}))
        }
    }
    checkEmpty = (string) =>{
        return string === "" || this.whiteSpaceTest.test(string)
    }
    validate = () =>{
        //app name validation
        if (this.checkEmpty(this.state.appName)){
            this.setState({appNameError:"App name is empty!"})
            return false
        }
        else if(!this.appNameTest.test(this.state.appName)){
            this.setState({appNameError:"App name can only consist of letters, numbers, and spaces"})
            return false
        }
        else if (this.state.appName.length > 30){
            this.setState({appNameError: "App name cannot be longer than 30 characters!"})
            return false
        }
        //package name validation
        if (this.checkEmpty(this.state.packageName)){
            this.setState({packageNameError: "Package name is empty!"})
            return false
        }
        else if(!this.packageNameTest.test(this.state.packageName)){
            this.setState({packageNameError: "Package name can only consist of letters!"})
            return false
        }
        this.setState({
            appNameError: "",
            packageNameError: "",
        })
        return true
    }
    render(){
        const { appName, appNameError,
            packageName, packageNameError } = this.state
        return(
            <div className="requestBuild">
                <h1 className="formTitle">Create Application</h1>
                <form className="requestForm">
                    <div className="formWrapper">
                        <div className="formEntry">
                            <h3>Your app's name:</h3>
                            <div className="inputContainer">
                                <input type="text" name="appName" value={appName} onChange={this.handleChange}
                                placeholder="A cool name! Less then 30 characters"/>
                                <p className="error">{appNameError}</p>
                            </div>
                        </div>
                        <div className="formEntry">
                            <h3>
                                Package name:
                                <div className="warningContainer">
                                    <FontAwesomeIcon className="warningIcon" icon={faExclamationCircle} />
                                    <span className="warning">You won't be able to change this field later</span>
                                </div>
                            </h3>
                            <div className="inputContainer">
                                <span className="packageName" onClick={()=>this.packageInput.current.focus()}>
                                    {PACKAGE_PREFIX}
                                    <input type="text" name="packageName" value={packageName} onChange={this.handleChange}
                                    placeholder="packageName" ref={this.packageInput}/>
                                </span>
                                <p className="error">{packageNameError}</p>
                            </div>
                        </div>
                    </div>
                    <div className="saveContainer">
                        <button className="saveBtn" onClick={this.handleSubmit}>
                            Create!
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

export default ApplicationForm